import React from 'react';
import {
  Col,
  FormFeedback,
  FormGroup,
  Input,
  Label,
  Row,
} from 'reactstrap';
import Text from '../../../components/Text';

export default function LeadsEmploymentView(props) {
  return (
    <>
      <FormGroup>
        <Row>
          <Col sm="auto" className="label-main">
            <Label htmlFor="bankruptcyCurrent">
              <Text value="Have you recently filed for bankruptcy" />
            </Label>
          </Col>
        </Row>
        <Input
          type="select"
          name="bankruptcyCurrent"
          id="bankruptcyCurrent"
          value={props.formData.bankruptcyCurrent}
          onChange={props.onChange}
          invalid={props.validations.bankruptcyCurrent?.isInvalid}
        >
          <option value="">Select an option</option>
          <option key="YES" value="YES">Yes</option>
          <option key="NO" value="NO">No</option>
        </Input>
        <FormFeedback>{ props.validations.bankruptcyCurrent?.message }</FormFeedback>
      </FormGroup>
      <FormGroup>
        <Row>
          <Col sm="auto" className="label-main">
            <Label htmlFor="bankruptcyFuture">
              <Text value="Are you planning on filing for bankruptcy" />
            </Label>
          </Col>
        </Row>
        <Input
          type="select"
          name="bankruptcyFuture"
          id="bankruptcyFuture"
          value={props.formData.bankruptcyFuture}
          onChange={props.onChange}
          invalid={props.validations.bankruptcyFuture?.isInvalid}
        >
          <option value="">Select an option</option>
          <option key="YES" value="YES">Yes</option>
          <option key="NO" value="NO">No</option>
        </Input>
        <FormFeedback>{ props.validations.bankruptcyFuture?.message }</FormFeedback>
      </FormGroup>
    </>
  );
}
